import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import SimpleSelect from "components/SimpleSelect";
import React from "react";
import PropTypes from "prop-types";
import {TextField, withStyles} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Button from "components/Button";
import WorkableIconButton from "components/button/WorkableIconButton";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "components/button/IconButton";
import ClearIcon from "@material-ui/icons/Clear";

const style = theme => ({
    root: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    spaceRight: {
        marginRight: theme.spacing(4)
    },
    gridWrapper: {
        '&:first-child': {
            width: 'calc(100% - 200px)'
        },
        '&:last-child': {
            width: '200px'
        }
    },
    search: {
        width: 250,
        marginBottom: theme.spacing(1)
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    },
    select: {
        width: 250,
        marginBottom: theme.spacing(1)
    }
})

function AuditTaskUserSearchBar({
    organizations,
    pickUsers,
    classes,
    setFilters,
    filters,
    onSubmit,
    onReset,
    searching
}) {

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            onSubmit();
        }
    }

    return (
        <>
            <GridBlock
                alignItems='flex-start'
                justify='space-between'
                itemClassName={classes.gridWrapper}
            >
                <GridBlock
                    alignItems='flex-end'
                    className={classes.root}
                    itemClassName={classes.spaceRight}
                >
                    <TextField
                        className={classes.search}
                        label={Tr('search_placeholder_fullname')}
                        onChange={e => setFilters({...filters, name: e.target.value})}
                        onKeyUp={handleKeyUp}
                        value={filters.name}
                        fullWidth

                    />
                    <TextField
                        className={classes.search}
                        label={Tr('email')}
                        onChange={e => setFilters({...filters, email: e.target.value})}
                        onKeyUp={handleKeyUp}
                        value={filters.email}
                        fullWidth

                    />
                    <SimpleSelect
                        label={Tr('organizational_unit')}
                        className={classes.select}
                        items={organizations}
                        onChange={(e) => setFilters({...filters, organization: e.target.value})}
                        value={filters.organization}
                    />
                    <div>
                        <WorkableIconButton Icon={SearchIcon} working={searching} onClick={onSubmit} tooltip={Tr('search')}/>
                        <IconButton disabled={searching} Icon={ClearIcon} tooltip={Tr('clear')} onClick={onReset}/>
                    </div>
                </GridBlock>
                <GridBlock
                    alignItems='flex-end'
                    justify='flex-end'
                >
                    <Button
                        className={classes.buttonNew}
                        color={'primary'}
                        variant={undefined}
                        onClick={pickUsers}

                    >
                        <AddIcon className={classes.icon}/>
                        {Tr('confirm2')}
                    </Button>
                </GridBlock>
            </GridBlock>
        </>
    )
}

AuditTaskUserSearchBar.propTypes = {
    classes: PropTypes.any,
}

AuditTaskUserSearchBar.defaultProps = {}

export default withStyles(style)(AuditTaskUserSearchBar);